import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeGb from '@angular/common/locales/en-GB';
import { LOCALE_ID, NgModule } from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import {
  OWL_DATE_TIME_FORMATS,
  OWL_DATE_TIME_LOCALE,
} from '@danielmoncada/angular-datetime-picker';
import { SharedModule } from './shared/shared.module';
import { environment } from 'src/environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { LoginModule } from './module/login/login.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './shared/interceptors/tokenInterceptor';
import { ApiModule as IdentityApiModule } from './api/identity/api.module';
import { ApiModule as ClinicalApiModule } from './api/clinical/api.module';
import { ApiModule as WmsApiModule } from './api/wms/api.module';
import {
  AppDateAdapter,
  APP_MAT_DATE_FORMATS,
  APP_OWL_DATE_TIME_FORMATS,
} from './shared/utils/app-date-formats.util';
import { TitleStrategy } from '@angular/router';
import { BrandingTitleStrategy } from './shared/branding/branding-title.strategy';

registerLocaleData(localeGb);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  exports: [ToastrModule],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MatDialogModule,
    ToastrModule.forRoot({
      timeOut: 1000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    LoginModule,
    IdentityApiModule.forRoot({ rootUrl: environment.apiUrlIdentity }),
    ClinicalApiModule.forRoot({ rootUrl: environment.apiUrlClinical }),
    WmsApiModule.forRoot({ rootUrl: environment.apiUrlWms }),
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-GB',
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB',
    },
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_MAT_DATE_FORMATS,
    },
    {
      provide: OWL_DATE_TIME_LOCALE,
      useValue: 'en-GB',
    },
    {
      provide: OWL_DATE_TIME_FORMATS,
      useValue: APP_OWL_DATE_TIME_FORMATS,
    },
    {
      provide: TitleStrategy,
      useClass: BrandingTitleStrategy,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
